import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningIcon from '@mui/icons-material/Warning';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { BackfillWarningDto } from 'providers/api';
import { is } from 'ramda';

const PREFIX = 'WarningBadge';

const classes = {
  warningIcon: `${PREFIX}-warningIcon`,
};

const StyledTooltip = styled(Tooltip)((
  {
    theme,
  },
) => ({
  [`& .${classes.warningIcon}`]: {
    color: theme.palette.warning.main,
  },
}));

interface WarningBadgeProps {
  warnings: BackfillWarningDto[] | string[];
}

const WarningBadge = ({ warnings }: WarningBadgeProps) => {
  if (warnings.length === 0) {
    return <CheckCircleOutlineIcon />;
  }

  return (
    <StyledTooltip
      title={
        warnings.map((warning) => (
          <Box>
            {is(String, warning) ? warning : (warning as BackfillWarningDto).display}
          </Box>
        ))
      }
    >
      <Badge badgeContent={warnings.length} color="secondary">
        <WarningIcon className={classes.warningIcon} />
      </Badge>
    </StyledTooltip>
  );
};

export default WarningBadge;
